import { parsePhoneE164, SelectOption } from '@globaleris/ui.library'
import { Contrato } from '../../api'
import { EnumTipoNotificacion } from '../../api/oData/enums/enumTipoNotificacion'
import { enumEnumToValueNumber, enumKeyToValue } from '../../helpers'

import {
  filterApplicableActionsConfiguration,
  getGlobalActionsConfiguration
} from './contactsInfo.service'
import { generateIconsFromConfiguration } from '../../helpers/dataTableActionIconHelper'
import { ActionIcons } from '../../model'
import { ContactInfoModelV3 } from '../../model/contactInfo'
export const contactsInfoItemsMapper = (items: ContactInfoModelV3[]): ContactInfoModelV3[] => {
  return items && items.map(contactInfoItemMapper)
}
export const contactInfoItemMapper = (item: ContactInfoModelV3): ContactInfoModelV3 => {
  return (
    item && {
      ...item,
      notificationTypes: item.notificationTypes?.map(type =>
        enumEnumToValueNumber(EnumTipoNotificacion, type)
      ) as EnumTipoNotificacion[],
      canDelete: item.principal ? false : true,
      actionsConfiguration: getGlobalActionsConfiguration(),
      phoneNumber: item.phoneNumber && item.phoneNumber !== '' ? item.phoneNumber : undefined
    }
  )
}

const DEFAULT_COUNTRY_CODE = '+34'

export const contactInfoRowMapper = (item: ContactInfoModelV3): ContactInfoModelV3 => {
  if (!item) return item

  if (!item.phoneNumber || item.phoneNumber.trim() === '') {
    return {
      ...item,
      phoneNumber: '',
      phoneCode: ''
    }
  }

  const phoneData = parsePhoneE164(item.phoneNumber)
  const countryCode = phoneData?.countryCode || DEFAULT_COUNTRY_CODE
  const nationalNumber = phoneData?.nationalNumber || item.phoneNumber

  return {
    ...item,
    phoneNumber: String(nationalNumber).replaceAll(' ', ''),
    phoneCode: countryCode
  }
}
export const contractsMapperToDropDown = (items: Contrato[]): SelectOption[] => {
  return items && items.map(contractMapperToDropDown)
}
export const contractMapperToDropDown = (item: Contrato): SelectOption => {
  return (
    item && {
      value: item.id,
      label: item.codContrato || ''
    }
  )
}
export const completeDataTableActions = (item: ContactInfoModelV3): ContactInfoModelV3 => {
  let finalPhoneNumber = ''

  //Si tenemos un numero de teléfono, comprobamos si es un número E164 válido. Si lo es, lo dejamos tal cual, si no lo es, añadimos el código de país al principio.
  //Este caso se podria dar ya que en la base de datos tenemos numeros de telefono que vienen ya con prefijo de pais.
  //Al guardar esto se corregirá y se guardara en formato E164, pero mientras tanto, para que se muestre correctamente en el form, hacemos esta comprobación.
  if (item.phoneNumber) {
    const parsed = parsePhoneE164(item.phoneNumber)

    if (parsed && parsed.nationalNumber) {
      finalPhoneNumber = item.phoneNumber
    } else {
      finalPhoneNumber = `${item.phoneCode || DEFAULT_COUNTRY_CODE}${item.phoneNumber}`
    }
  }

  return {
    ...item,
    phoneNumber: finalPhoneNumber,
    actions:
      item.actionsConfiguration &&
      item.actionsConfiguration.length > 0 &&
      generateIconsFromConfiguration(
        item,
        filterApplicableActionsConfiguration(item, item.actionsConfiguration),
        new Map<ActionIcons, Function>([])
      )
  }
}
